import React from 'react';
interface ClosedOrder {
  market: string;
  side: 'Buy' | 'Sell';
  type: string;
  price: string;
  quantity: string;
  status: 'Filled' | 'Canceled';
  dateTime: string;
  leverage: string;
  reduceOnly?: boolean;
}
const mockClosedOrders: ClosedOrder[] = [{
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Limit',
  price: '95,790.6',
  quantity: '0.00082670',
  status: 'Filled',
  dateTime: '1/15/26 11:35 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '-',
  quantity: '-',
  status: 'Canceled',
  dateTime: '1/15/26 5:59 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Sell',
  type: 'Market',
  price: '91,772.5',
  quantity: '0.00115416',
  status: 'Filled',
  dateTime: '12/12/25 4:18 PM',
  leverage: '10x',
  reduceOnly: true
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '93,487.8',
  quantity: '0.00115416',
  status: 'Filled',
  dateTime: '12/11/25 10:31 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '93,463.7',
  quantity: '0.00186441',
  status: 'Filled',
  dateTime: '12/11/25 10:31 PM',
  leverage: '10x',
  reduceOnly: true
}];
export function ClosedOrdersTable() {
  if (mockClosedOrders.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-1348">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-1349">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-1350">
            <polyline points="9 11 12 14 22 4" data-id="element-1351" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" data-id="element-1352" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-1353">No closed orders.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-1354">
      <table className="w-full" data-id="element-1355">
        <thead className="sticky top-0 bg-background-secondary z-10" data-id="element-1356">
          <tr className="border-b border-border-subtle" data-id="element-1357">
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1358">
              Market
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1359">
              Side
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1360">
              Type
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1361">
              Price
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1362">
              Quantity
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1363">
              Status
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1364">
              Date & Time
            </th>
          </tr>
        </thead>
        <tbody data-id="element-1365">
          {mockClosedOrders.map((order, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors" data-id="element-1366">
              <td className="px-4 py-3" data-id="element-1367">
                <div className="flex items-center gap-2" data-id="element-1368">
                  <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.svg" alt="BTC" className="w-5 h-5" data-id="element-1369" />
                  <span className="font-medium text-text-primary" data-id="element-1370">
                    {order.market}
                  </span>
                  <span className="text-xs text-text-tertiary bg-background-elevated px-1.5 py-0.5 rounded" data-id="element-1371">
                    {order.leverage}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-1372">
                <div className="flex items-center gap-2" data-id="element-1373">
                  <span className={`text-sm font-medium ${order.side === 'Buy' ? 'text-success' : 'text-danger'}`} data-id="element-1374">
                    {order.side}
                  </span>
                  {order.reduceOnly && <span className="text-xs text-text-tertiary" data-id="element-1375">(Reduce)</span>}
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-1376">
                <span className="text-sm text-text-primary" data-id="element-1377">{order.type}</span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1378">
                {order.price !== '-' ? <div className="font-mono text-sm text-text-primary" data-id="element-1379">
                    {order.price}
                    <span className="text-text-secondary text-xs ml-1" data-id="element-1380">
                      USD
                    </span>
                  </div> : <span className="text-sm text-text-tertiary" data-id="element-1381">-</span>}
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1382">
                {order.quantity !== '-' ? <div className="font-mono text-sm text-text-primary" data-id="element-1383">
                    {order.quantity}
                    <span className="text-text-secondary text-xs ml-1" data-id="element-1384">
                      BTC
                    </span>
                  </div> : <span className="text-sm text-text-tertiary" data-id="element-1385">-</span>}
              </td>
              <td className="px-4 py-3" data-id="element-1386">
                <span className={`text-sm font-medium ${order.status === 'Filled' ? 'text-success' : 'text-danger'}`} data-id="element-1387">
                  {order.status}
                </span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1388">
                <span className="text-sm text-text-secondary" data-id="element-1389">
                  {order.dateTime}
                </span>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}